import { Cell, Grid, HeadingSection, InfoLabel } from 'bold-ui'
import { Cep } from 'components/label'
import React from 'react'

export interface EnderecoSectionModel {
  bairro?: string
  cep?: string
  complemento?: string
  logradouro?: string
  municipio?: {
    nome: string
  }
  numero?: string
  pontoReferencia?: string
  semNumero?: boolean
  tipoLogradouro?: {
    nome: string
  }
  uf?: {
    sigla: string
  }
}

export interface EnderecoSectionProps {
  endereco: EnderecoSectionModel
  title: string
  renderTipoLogradouro?: boolean
}

export function EnderecoSection(props: EnderecoSectionProps) {
  const { title, endereco, renderTipoLogradouro } = props
  return (
    <HeadingSection level={2} title={title}>
      <Grid wrap>
        <Cell size={12} data-cy='EnderecoSection.cep'>
          <InfoLabel title='CEP'>
            <Cep value={endereco?.cep} />
          </InfoLabel>
        </Cell>
        <Cell size={4} data-cy='EnderecoSection.estado'>
          <InfoLabel title='Estado'>{endereco?.uf?.sigla}</InfoLabel>
        </Cell>
        <Cell size={4} data-cy='EnderecoSection.municipio'>
          <InfoLabel title='Município'>{endereco?.municipio?.nome?.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4} data-cy='EnderecoSection.bairro'>
          <InfoLabel title='Bairro'>{endereco?.bairro?.titleCase()}</InfoLabel>
        </Cell>
        {renderTipoLogradouro && (
          <Cell size={4} data-cy='EnderecoSection.tipoLogradouro'>
            <InfoLabel title='Tipo de logradouro'>{endereco?.tipoLogradouro?.nome?.titleCase()}</InfoLabel>
          </Cell>
        )}
        <Cell size={4} data-cy='EnderecoSection.logradouro'>
          <InfoLabel title='Logradouro'>{endereco?.logradouro?.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4} data-cy='EnderecoSection.numero'>
          <InfoLabel title='Número'>{endereco?.semNumero ? 'S/N' : endereco?.numero?.toUpperCase()}</InfoLabel>
        </Cell>
        <Cell size={4} data-cy='EnderecoSection.complemento'>
          <InfoLabel title='Complemento'>{endereco?.complemento?.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4} data-cy='EnderecoSection.pontoReferencia'>
          <InfoLabel title='Ponto de referência'>{endereco?.pontoReferencia?.capitalize()}</InfoLabel>
        </Cell>
      </Grid>
    </HeadingSection>
  )
}
